import { supabase_stories } from "./supabase"




export async function LoginUser(credentials: { email: string, password: string }) {
    const { data, error } = await supabase_stories.auth.signInWithPassword({
        email: credentials.email,
        password: credentials.password,
    })
    console.log( data, error )
    return { data, error }
}





export async function RefreshSession(refresh_token:string ) {
    const { data, error } = await supabase_stories.auth.refreshSession({refresh_token})
    console.log( data, error )
    return { data, error }
}